import React from 'react';
import PropTypes from 'prop-types';

import CardSelectFields from './cards';
import RadioGroupFields from './radio';

const EditableFlowMapper = ({ type, ...rest }) => {
  switch (type) {
    case 'radio':
      return <RadioGroupFields {...rest} />;
    case 'cards':
      return <CardSelectFields {...rest} />;
    default:
      return null;
  }
};

EditableFlowMapper.propTypes = {
  type: PropTypes.string,
};

export default EditableFlowMapper;
